/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { PosWeightQuantityModal } from './modals/PosWeightQuantityModal';
import type { Product } from '../../catalog/domain-api';

type Props = {
  visible: boolean;
  product: Product | null;
  onCancel: () => void;
  onConfirm: (quantity: number) => void;
};

export function PosHourQuantityModal({ visible, product, onCancel, onConfirm }: Props) {
  return (
    <PosWeightQuantityModal
      visible={visible}
      product={product}
      onCancel={onCancel}
      onConfirm={onConfirm}
      heading="Cantidad en horas"
    />
  );
}
